module.exports = __webpack_public_path__ + "img/paris.91eb36fc.jpg";